/* eslint-disable no-unused-expressions */
import React, {useState, useEffect,useMemo} from 'react';
import { Scrollbars } from 'react-custom-scrollbars';
import axios from 'axios';
import load from '../../images/market/loaderVideo.mp4';

import tick  from '../../images/accumulation/tick.png';
import monos  from '../../images/accumulation/monos.png';
import filters  from '../../images/market/filter.png';
import sort  from '../../images/market/sort.png';
import fire from '../../images/market/fire.gif';
import { getAssetInfo } from '../../web3Helper';
import FilterBox from './FilterBox';
import queryString from 'query-string';
import { checkIsWalletConnected, checkNetwork } from '../../web3Utils';
import { getNetworkName } from '../../utils';

const RenderData = ({history, location, match}) => {
  const [filter, setFilter] = useState(false);
  const [loader, setLoader] = useState(false);
  const [search, setSearch] = useState('');
  const [blockChainloader, setblockChainloader] = useState(true);
  const [inventoryArray, setInventoryArray] = useState([]);
  const [inventoryArray2, setInventoryArray2] = useState([]);

  const [isWalletConnected, setIsWalletConnected] = useState(false);
  const [isCorrectNetwork, setIsCorrectNetwork] = useState(false);

  const getInventories = async (search)=> {
    let searchQuery = queryString.parse(location.search);
    let searchParam = search ? search : (searchQuery && searchQuery.search) ? searchQuery.search : '';
    setLoader(true);
    setInventoryArray([])
    const category  =match.params.name === 'coin box' ? 'COIN_BOX' : match.params.name
    try {
    const response = await axios.get(`api/app/asset/marketplace?category=${category.toUpperCase()}&search=${searchParam}&`);
    setInventoryArray(response.data.items);
    setInventoryArray2(response.data.items);
    setLoader(false);

    }
    catch(e) {
    setLoader(false);
      console.log(e);
    }    
  }
  useEffect(()=> {
    if(inventoryArray.length > 0){

      getAssetAvailability();
    }
  },[inventoryArray2])
  useEffect(()=> {
    getInventories('','','');
  },[match, location]);

  useEffect(()=> {
    checkIsWalletConnected().then((isConnected) => setIsWalletConnected(isConnected))
    checkNetwork().then((isNetworkId) => setIsCorrectNetwork(isNetworkId))
  },[])

  const getBySearch  = (value) => {
    setSearch(value);
    getInventories(value)
  }
  const getAssetAvailability = (getAssetInfoPromises)=> {
    setblockChainloader(true)
      const array =  [...inventoryArray];
      for(var i=0; i< array.length; i++) {
       
          array[i].quantityFromChain = 0 
          array[i].available = true;
      }
      setInventoryArray(array)
      setblockChainloader(false)

  }

  return (
    <div className="main-box">
      <div className="filters-div">
        <div className="input-group mb-3 mt-3">
          <div className="input-div">
            <input placeholder="Search marketplace" onChange={e=> getBySearch(e.target.value)} type="searxh" className="form-control"/>
          </div>
            <button onClick={()=> history.push(`/market-place/assets/${match.params.name}?search=${search}`)} className="btn buy" type="button">Search</button>
          </div>
          <div className="advnace-div">
          {/* <p className="filter" >Advance Filters <img src={filters} alt=""/></p> */}
          {filter && <FilterBox getInventory={getInventories} />}
          {/* <p>Sort <img src={sort} alt=""/></p> */}
          </div>
        </div>
        <Scrollbars style={ { height: 400, width: '100%' } }
            autoHide
          className="scroll-right"
          renderTrackHorizontal={ props => <div { ...props } className="track-horizontal"/> }
          renderTrackVertical={ props => <div { ...props } className="track-vertical"/> }>
            <div className="row no-gutters">
            {loader &&
            <video className="video" autoPlay loop muted>
            <source src={load} type='video/mp4' />
          </video>}
            {inventoryArray.map(arr => (
            <div className="col-lg-6 col-sm12">
              <div
               onClick={()=> history.push({pathname: `/market-place/asset/${match.params.name}/${arr._id}`, state:{name: arr.name}}) }
                className="sub-box">
                <img className="profile" src={arr.imageUrl} alt="" />
                <span className="line"></span>
                <div className="right">
                  <div className="sub-right">
                    <h5>{arr.name.toUpperCase()}</h5>
                    { 
                      blockChainloader ? 
                        <img className="fire" src={fire} alt=""/> 
                      : !arr.isMarketPlaceItem || !isWalletConnected || !isCorrectNetwork  ?
                        <span>N.A</span>
                      : <span><img src={tick} alt=""/> AVAILABLE</span>
                    }
                  </div>
                  <div className="sub-right">
                    {/* <div>
                      <span>LAST SOLD FOR</span>
                      <p><img src={monos} alt=""/> {arr.sold}</p>
                    </div> */}
                    <div>
                      <span>Token ID</span>
                      <p>
                        { 
                          blockChainloader ? 
                            <img className="fire" src={fire} alt=""/> 
                          : !isWalletConnected ?
                            'Connect your Wallet.'
                          : !isCorrectNetwork ?
                            `Switch to ${getNetworkName(process.env.REACT_APP_MAIN_NETWORK_ID)} Network.`
                          : arr?.tokenId?.[Number(process.env.REACT_APP_MAIN_NETWORK_ID)] || 'N.A' 
                        }
                      </p>
                    </div>
                    <div className={`${arr.attributes.type ? 'type-div' : ''}`}> 
                      <span>TYPE</span>
                      <p>{arr.attributes.type?arr.attributes.type.replace(/_/g, " ") : '-'}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))}
          </div>
        </Scrollbars>
    </div>
          
  )
}

export default RenderData;